import {Component, Input, OnInit} from '@angular/core';
import {AppUser} from "../../../../../framework/model/core/appuser/appuser";
import {OrderService} from "../../../../services/OrderService";
import {Events} from "../../../../../framework/providers/events";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {ModelClasses} from "../../../../model/modelClasses";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {PaymentPage} from "../../../cart/pages/payment/payment.page";
import {ItemProvider} from "../../../item/providers/item-provider/item-provider.service";
import {ApiTableComponent} from "../../../../../framework/components/list/api-table/api-table.component";
import {AlertController, Platform} from "@ionic/angular";
// import { FileOpener } from '@capacitor-community/file-opener';
import { Filesystem, Directory } from '@capacitor/filesystem';
import {Share} from "@capacitor/share";
import {Capacitor} from "@capacitor/core";
import { FileOpener } from '@capawesome-team/capacitor-file-opener';


@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponent implements OnInit {
    @Input()
    public modelId;
    @Input()
    public title: boolean = true;

    @Input()
    public key?:string;

    public appuser: AppUser;
    // public models: Array<AppUser> = [];
    public options: object = {};
    public tabs: object = {'value': null, "data": []};
    public filters;
    public companyData;

    public prefix: string = 'inv_';

    // public prefix: string = 'inv_' + Math.floor(Math.random() * Math.floor(1000000));

    constructor(public orderService: OrderService, public events: Events, public modelProvider: ModelProvider, public modelClasses: ModelClasses, public itemProvider: ItemProvider,
                public tools: ModelToolsProvider, private platform: Platform, private alertController: AlertController) {
        this.appuser = this.orderService.getAppUser();
    }

    ngOnInit() {
        console.log("INVOICEE!!!")
        this.filters = {'company': this.modelId};

        this.modelProvider.custom('getInvoiceInterface', {
            'setPrefix': false,
            'company': this.modelId,
            'key': this.key,
            'pdf': true, // can handle pdf files.
            'mode': 'api_types'
        }).then((res) => {
            if (res['res']) {
                this.setInterfaceData(res);
            } else {
                this.setDefaultData();
            }
        });

        this.setTab(false);
    }

    setInterfaceData(res) {
        let models = res['models'];
        for (let modelData of models) {
            let cls = this.modelClasses.getClass(modelData['modelName']);
            let model = new cls({});
            let fields = modelData['fields'] ? modelData['fields'] : model.fields;
            let data = {
                'value': modelData['name'] ? modelData['name'] : modelData['modelName'],
                'model': model,
                'title': modelData['name'] ? modelData['name'] : modelData['modelName'],
                'checked': true,
                'modelName': modelData['modelName'],
                'display': 'table',
                'header': fields,
                'fields': fields,
                'calcable': modelData['calcable'],
                'checkedData': {'checked': {}, 'data': {}, 'balance': 0, 'amount': 0},
                'filters': modelData['filters'],
                'options': modelData['options'],
                'models': [],
                'prefix': this.tools.getRandomize()
            };
            this.tabs['data'].push(data);
            if (!this.tabs['value']) this.tabs['value'] = data['value'];
        }

        this.companyData = res['company_data']
    }

    setDefaultData() {
        this.tabs['value'] = 'checks';
        this.tabs['data'] = [
            {
                'value': 'checks',
                'title': 'checks',
                'checked': true,
                'modelName': 'bandObligoChecks',
                'display': 'table',
                'header': ['payDate', 'cardNum', 'qprice', 'currency'],
                'fields': ['payDate', 'cardNum', 'qprice', 'code'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'checksList'
            },
            {
                'value': 'openDebt',
                'title': 'openDebt',
                'checked': true,
                'modelName': 'bandObligoFncitems',
                'display': 'card',
                'fields': ['balDate', 'ivnum', 'fncPatname', 'details', 'price', 'fncDate'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'openDebtList'
            },
            {
                'value': 'withoutCharge',
                'title': 'withoutCharge',
                'checked': false,
                'modelName': 'bandObligoTrans',
                'display': 'table',
                'header': ['curDate', 'docno', 'price', 'currency'],
                'fields': ['curDate', 'docno', 'price', 'currencyCode'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'withoutChargetList'
            }
        ]
    }

    setTab(event = null) {
        if (event) {
            this.tabs['value'] = event['detail']['value'];
        }
    }

    setChecked(tab, model) {
        let amount = 0;
        let toPay = 0;
        let toPay_ids = [];
        let balance = 0;
        let checked = tab['checkedData']['checked'];
        tab['checkedData']['data'][model.data.id] = model;
        for (let key in checked) {
            let invoice = tab['checkedData']['data'][key];
            let invoice_balance = parseFloat(invoice.data.balance);
            if (checked[key]) {
                amount++;
                balance += invoice_balance;

                if (tab['options']['payment_allow'] && !invoice.data.paymentVerified) {
                    toPay += invoice_balance
                    toPay_ids.push(invoice.data.id)
                }
            }
        }


        tab['checkedData']['amount'] = amount;
        tab['checkedData']['balance'] = balance;
        tab['checkedData']['toPay'] = toPay;
        tab['checkedData']['toPay_ids'] = toPay_ids;
    }

    refresh(prefix) {
        this.events.publish(prefix + '_updateFilter', {'refresh': true});
    }

    setModel(model, tab) {
        let options = tab['options']
        console.log(model)
        console.log(options)
        console.log(tab)

        if (model.data['order']) {
            this.tools.goTo('order/' + model.data['order'])
            return;
        }

        if (!options['onclick'])
            return

        if (model.data.item && options['onclick']['page'] == 'item/') {
            let item = this.itemProvider.getItemById(model.data.item);
            this.itemProvider.openItem(item);
            return;
        }

        if (options['onclick']['url_callback']) {
            let me = this;
            this.tools.yesOrNoAlert(function () {
                me.modelProvider.customPost(options['onclick']['url_callback'], {'modelId': model.data[options['onclick']['modelKey']],}, {'setPrefix': true}).then((res) => {
                    me.modelProvider.presentToast(me.tools.getTranslate(res['data']['res']), true, res['data']['color']);
                    me.events.publish(tab['prefix'] + '_updateModels', tab['filters']);
                })
            })
        }
    }

    viewApiInvoiceTable(model) {
        if (!model.data['ref1']) return;
        let filters = model.data;
        filters['setPrefix'] = true;
        this.modelProvider.custom('apiInvoiceDetails', filters).then((res) => {
            this.tools.showModal(ApiTableComponent, res, 'animated-popover full-size-modal');
        })
    }


    async getPDF(model) {
        let filters = model.data
        filters['setPrefix'] = true
        this.modelProvider.loading();

        this.modelProvider.custom('getInvoicePdf', filters).then((res) => {
            this.modelProvider.loadingOff();

            if (!res['file_Content']) return
            const pdfBase64 = res['file_Content'];
            if (this.platform.is('cordova')) {
                this.openPDFMobile(pdfBase64, filters['ref1'])
            } else
                this.openPDFweb(pdfBase64)

        })
    }

    openPDFweb(pdfBase64: string) {
        const pdfWindow = window.open("");
        pdfWindow.document.write(
            `<iframe width="100%" height="100%" src="data:application/pdf;base64, ${pdfBase64}"></iframe>`
        );
    }

    filterByField(tab: any, field: string) {
      // Extract unique values from tab['models'] based on the selected field
    if(!tab['coreModels']) tab['coreModels'] = tab['models'];

      const uniqueValues = Array.from(
        new Set(tab['coreModels'].map((model: any) => model.data[field]?.toString() || ''))
      );

      // Show an ion-alert to let the user select a filter option
      this.alertController.create({
        header: `Filter by ${field}`,
        inputs: uniqueValues.map(value => ({
          name: 'filter',
          type: 'radio',
          label: value.toString(),  // Ensure label is a string
          value: value.toString()   // Ensure value is a string
        })),
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'Apply',
            handler: (selectedValue: string) => {
              tab['models'] = tab['coreModels'].filter((model: any) => model.data[field]?.toString() === selectedValue);
            }
          }
        ]
      }).then(alert => alert.present());
    }


    async openPDFMobile(pdfBase64: string, filename: string) {
      try {
        const fileName = `${filename}-${Date.now()}.pdf`;

        await Filesystem.writeFile({
          path: fileName,
          data: pdfBase64,
          directory: Directory.Cache,
          recursive: true
        });

           const { uri } = await Filesystem.getUri({
            directory: Directory.Cache,
            path: fileName,
          });

          await FileOpener.openFile({
            path: uri,            // content:// or file:// is fine
            mimeType: 'application/pdf', // optional
          });

      } catch (error) {
        console.error('Error opening PDF:', error);
      }
    }

    exportInvoice(tab, type){
        let filters = tab['filters'];
        filters['setPrefix'] = true;
        filters['type'] = type;
        this.modelProvider.loading();

        this.modelProvider.custom('getInvoiceReport', filters).then((res) => {
            this.modelProvider.loadingOff();
            this.tools.textAlert('theReportHasBeenSentToYourEmail', '', null, true);
        })
    }


    payInvoice(tab) {
        let prefix = 'invoice_new_payment_' + this.tools.getRandomize();
        this.tools.showModal(PaymentPage, {
            'params': {'invoices': tab['checkedData']['toPay_ids'].join(','), 'prefix': prefix}
        })

        this.events.subscribe(prefix, (res) => {
            Object.keys(tab['checkedData']['checked']).forEach(key => {
                delete tab['checkedData']['checked'][key];
            })

            tab['checkedData']['amount'] = 0;
            tab['checkedData']['balance'] = 0;
            tab['checkedData']['toPay'] = 0;
            tab['checkedData']['toPay_ids'] = [];


            this.events.publish(tab['prefix'] + '_updateModels');
            this.events.unsubscribe(prefix);
        })

    }

}

// Helper function to convert Base64 to Blob
function base64ToBlob(base64: string, mimeType: string): Blob {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {type: mimeType});
}